// 공개 회사정보 조회 유틸 (인증 불필요, 메모리 캐시)
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const DEFAULTS = {
  company_name: process.env.REACT_APP_COMPANY_NAME || '',
  ceo_name: '',
  company_phone: '',
  company_address: '',
  business_number: '',
  bank_name: '',
  account_number: '',
  account_holder: '',
};

let cache = null;
let pending = null;

export async function fetchCompanyInfo(force = false) {
  if (!force && cache) return cache;
  if (!force && pending) return pending;
  pending = axios.get(`${API_URL}/public/company-info`)
    .then((res) => {
      cache = { ...DEFAULTS, ...(res.data?.data || {}) };
      return cache;
    })
    .catch(() => ({ ...DEFAULTS }))
    .finally(() => { pending = null; });
  return pending;
}

export function clearCompanyInfoCache() { cache = null; }

export { DEFAULTS as companyInfoDefaults };
